(()=>{
 document.addEventListener('click',event=>{
  const filter=event.target.closest('[data-bp-filter]');
  if(filter){const section=filter.closest('[data-bp-portfolio]');section.querySelectorAll('[data-bp-filter]').forEach(button=>{const active=button===filter;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active));});section.querySelectorAll('[data-bp-category]').forEach(card=>{card.hidden=filter.dataset.bpFilter!=='all'&&card.dataset.bpCategory!==filter.dataset.bpFilter;if(card.hidden)card.querySelectorAll('video').forEach(video=>video.pause());});}
  const service=event.target.closest('[data-bp-service]');
  if(service){document.querySelectorAll('[data-bp-service-option]').forEach(input=>{if(input.dataset.bpServiceOption===service.dataset.bpService)input.checked=true;});}
  const menuLink=event.target.closest('.bp-mobile-menu a');if(menuLink)menuLink.closest('details').open=false;
 });
 document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('[data-bp-category]');if(card){const section=card.closest('[data-bp-portfolio]');section.querySelector('[data-bp-filter="all"]')?.click();}});
})();

(()=>{
 const initialize=()=>document.querySelectorAll('[data-bp-phone]').forEach(group=>{
  if(group.dataset.ready)return;group.dataset.ready='true';
  const input=group.querySelector('[data-bp-phone-number]'),select=group.querySelector('[data-bp-calling-code]'),form=input.form;
  const normalize=()=>{
   const raw=input.value.trim(),option=select.selectedOptions[0];input.setCustomValidity('');if(!raw)return input.required?null:'';
   if(!/^[+0-9() .-]+$/.test(raw)||!option)return null;
   let digits=raw.replace(/[^0-9]/g,''),international=raw.startsWith('+')||raw.startsWith('00');
   if(raw.startsWith('00'))digits=digits.slice(2);
   const code=option.dataset.code;
   if(international){if(!digits.startsWith(code))return null;digits=digits.slice(code.length);}
   const pattern=new RegExp('^(?:'+option.dataset.pattern+')$');
   if(!international&&!pattern.test(digits)){const prefix=option.dataset.prefix;if(/^[0-9]+$/.test(prefix)&&digits.startsWith(prefix))digits=digits.slice(prefix.length);}
   if(!pattern.test(digits)||code.length+digits.length>15)return null;
   return '+'+code+digits;
  };
  const validate=()=>{const value=normalize();input.setCustomValidity(value===null?group.dataset.error:'');return value;};
  input.addEventListener('input',validate);select.addEventListener('change',validate);
  form.addEventListener('submit',event=>{const value=validate();if(value===null){event.preventDefault();input.reportValidity();}else if(value)input.value=value;});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
 document.addEventListener('shopify:section:load',initialize);
})();

(()=>{
 const initialize=()=>document.querySelectorAll('.bp-contact-form').forEach(form=>{
  if(form.dataset.bpCompleteInquiry)return;
  form.dataset.bpCompleteInquiry='true';
  form.addEventListener('formdata',event=>{
   const data=event.formData;
   const text=name=>String(data.get('contact['+name+']')||'').trim();
   const services=Array.from(form.querySelectorAll('[data-bp-service-option]:checked'),input=>input.dataset.bpServiceOption).filter(Boolean).join(', ');
   const phone=text('phone'),country=text('Phone country'),brief=text('body');
   const lines=[
    'Name: '+(text('name')||'Not provided'),
    'Brand / company: '+(text('brand')||'Not provided'),
    'Email: '+(text('email')||'Not provided'),
    'Country / calling code: '+(country||'Not provided'),
    'Mobile number: '+(phone||'Not provided'),
    'Selected services: '+(services||'Not specified'),
    'Estimated budget (USD): '+(text('budget')||'Not provided'),
    'Preferred timeline: '+(text('timeline')||'Not provided'),
    '',
    'Project brief:',
    brief||'Not provided'
   ];
   data.set('contact[Selected services]',services||'Not specified');
   data.set('contact[Mobile number]',phone);
   data.set('contact[body]',lines.join('\n'));
  });
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
 document.addEventListener('shopify:section:load',initialize);
})();
